/**
 * breakpoints is an object that holds the pixel widths at which to apply certain styles for different device sizes
 * It contains properties for small (sm), medium (md), large (lg), and extra large (xl) devices
 */
const breakpoints = {
    sm: 576, // Small devices (landscape phones, less than 768px)
    md: 768, // Medium devices (tablets, less than 992px)
    lg: 992, // Large devices (desktops, less than 1200px)
    xl: 1200, // Extra large devices (large desktops, 1200px and up)
};

export default breakpoints;
